import { defineFcm } from '../shared/factory';

export const FCM_DISABLE_GEOLOCATION_GUEST_SIGN_FORM = defineFcm('disable_geolocation_guest_sign_form')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description:
			'If true, geolocation for guests is disabled, meaning the localization fields (e.g. country, city, ...) will not be pre-filled.',
	});
